import { render, staticRenderFns } from "./settings-container.vue?vue&type=template&id=c7f6c3c8&scoped=true&"
import script from "./settings-container.vue?vue&type=script&lang=js&"
export * from "./settings-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f6c3c8",
  null
  
)

export default component.exports